import { render, staticRenderFns } from "./PricesServiceRow.vue?vue&type=template&id=3baa281c&scoped=true&"
import script from "./PricesServiceRow.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PricesServiceRow.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PricesServiceRow.vue?vue&type=style&index=0&id=3baa281c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baa281c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3baa281c')) {
      api.createRecord('3baa281c', component.options)
    } else {
      api.reload('3baa281c', component.options)
    }
    module.hot.accept("./PricesServiceRow.vue?vue&type=template&id=3baa281c&scoped=true&", function () {
      api.rerender('3baa281c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/components/PricesServiceRow.vue"
export default component.exports